export enum PreferredLanguageEnum {
  sv = "sv",
  fi = "fi",
  en = "en",
}

export type SupportedLanguage = "sv" | "en" | "fi";

export enum PromotionTypeEnum {
  INTEREST_FREE = "INTEREST_FREE",
  AMORTISATION_FREE = "AMORTISATION_FREE",
}

export enum CountryCode {
  SE = "SE",
  FI = "FI",
}

export enum Currency {
  SEK = "SEK",
  EUR = "EUR",
}

export enum AppName {
  ADMIN = "ADMIN",
  PARTNER = "PARTNER",
  CUSTOMER = "CUSTOMER",
  WIDGET = "WIDGET",
}

export enum BidType {
  COMPANY_LOAN = "COMPANY_LOAN",
  FACTORING = "FACTORING",
  REAL_ESTATE = "REAL_ESTATE",
  LEASING = "LEASING",
  REVOLVING_CREDIT = "REVOLVING_CREDIT",
  PURCHASE_FINANCING = "PURCHASE_FINANCING",
}

export enum LeadType {
  BUSINESS_LOAN_CALCULATOR_LEAD = "BUSINESS_LOAN_CALCULATOR_LEAD",
  REAL_ESTATE_CALCULATOR_LEAD = "REAL_ESTATE_CALCULATOR_LEAD",
  LEASING_CALCULATOR_LEAD = "LEASING_CALCULATOR_LEAD",
  FACTORING_CALCULATOR_LEAD = "FACTORING_CALCULATOR_LEAD",
  PRELIMINARY_LOAN_AMOUNT_LEAD = "PRELIMINARY_LOAN_AMOUNT_LEAD",
  PRE_DRAFT_LEAD = "PRE_DRAFT_LEAD",
  ELIGIBILITY_CHECK_LEAD = "ELIGIBILITY_CHECK_LEAD",
  MANUAL = "MANUAL",
  ADVISORY_CONTACT_US_FORM_LEAD = "ADVISORY_CONTACT_US_FORM_LEAD",
}

export enum AmortizationMethod {
  ANNUITY = "ANNUITY",
  LINEAR = "LINEAR",
  FIXED = "FIXED",
  BULLET = "BULLET",
  BUILDING_CREDIT = "BUILDING_CREDIT",
}

export interface ITranslationObject<T = Record<string, unknown>> {
  en: T;
  sv: T;
  fi: T;
  namespace: string;
}

export interface IReviewProviderScoreData {
  provider: string;
  score: number;
  maxScore: number;
  numberOfReviews: string;
  linkToProviderReviews: string;
}

export enum CallbackPageType {
  BANKING_DATA = "banking-data",

  // Whitelisted url for FI Bank ID callback handling. Dont change lightly.
  // See Nets FI BankID in 1password for more details.
  FI_BANK_ID = "fi-bank-id",
}

export enum EnvironmentEnum {
  PRODUCTION = "production",
  STAGING = "staging",
  DEVELOPMENT = "development",
  TEST = "test",
}

export interface IPreliminaryLoanAmountData {
  estimatedMaxLoanAmount: number;
  probabilityLoanApproved: string;
  useEdgeCaseLogic: boolean;
  estimatedMinLoanAmount: number;
  conversionValue: number | null;
}
